import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';

import { User, UserType } from '../../shared/models/user/user.model';
import { BaseComponent } from '../../shared/components/base/base.component';
import { NavigationService } from '../../shared/services/navigation/navigation.service';

import { WebHelperService } from '../../shared/services/web-helper/web-helper.service';
import { ButtonComponent } from '../button/button.component';
import { DATA_INJECTION_TOKEN } from '../../ngrx/modal/services/modal.service';
import { ILang } from '../../ngrx/locale/states/locale.state';
import { IAppState } from '../../ngrx';
import { getUserRole, USER_ROLE } from '../../shared/helpers/roles';
import { Observable } from 'rxjs';
import { GeneralNotifications } from '../../shared/models/notification/notification.model';
import { transitionAnimation } from '../../../scss/themes/animation';
import { IndustriesMenuComponent } from '../../website/industries-menu/industries-menu.component';



@Component({
    selector: 'app-mobile-menu',
  imports: [
    CommonModule,
    RouterLink,
    TranslateModule,
    ButtonComponent,
    NgOptimizedImage,
    RouterLinkActive,
    IndustriesMenuComponent
],
    templateUrl: './mobile-menu.component.html',
    styleUrl: './mobile-menu.component.scss',
    animations: [transitionAnimation]
})
export class MobileMenuComponent extends BaseComponent implements OnInit {
  type: 'website' | 'application' = 'application';
  companySearchName: string;
  user: User;
  languages: ILang[];
  activeLanguage: string;
  noAuth: boolean;
  hasAdvancedTemplateOnly: boolean;
  userType: UserType;
  notifications$: Observable<GeneralNotifications>;

  constructor(
    @Inject(DATA_INJECTION_TOKEN) public data: any,
    readonly webHelper: WebHelperService,
    readonly router: Router,
    private readonly store: Store<IAppState>,
    private readonly navigationService: NavigationService,
  ) {
    super();

    this.type = data.type;
    this.companySearchName = data.companySearchName;
    this.user = data.user;
    this.languages = data.languages;
    this.noAuth = data.noAuth;
    this.hasAdvancedTemplateOnly = data.hasAdvancedTemplateOnly;
    this.userType = data.userType;
    this.notifications$ = data.notifications$;
  }

  get typeIsWebsite(): boolean {
    return this.type === 'website';
  }

  ngOnInit(): void {
    this.store.pipe(
        select((s) => s.ui.locale),
        takeUntil(this.destroy$),
      ).subscribe((lang: string) => {
        this.activeLanguage = lang;
      });
  }

  close(): void {
    this.navigationService.detachOverlay();
  }

  public selectLanguage(lang: ILang): void {
    this.webHelper.changeLanguage(lang.code);
    this.close();
  }

  protected readonly getUserRole = getUserRole;
  protected readonly USER_ROLE = USER_ROLE;
}
